module.exports = __webpack_public_path__ + "img/pirate-new-year.af90b479.svg";